import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import media from '../../styles/config/mediaQueries';

const StyledSwitcher = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${media.mobile`
    ${props =>
      props.lighterBg &&
      `
        background-color: #121212;
      `}
  `}
  ${media.desktop`
    margin-bottom: 25px
  `}
`;

const SwitcherButton = styled.button`
  ${typeStyle['font-14-semi-bold']}
  flex: 1 0 50%;
  padding: 19px 60px;
  text-align: center;
  text-transform: uppercase;
  position: relative;
  &:not(:last-child) {
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);
      width: 1px;
      height: 32px;
      background-color: ${rgba(theme.color.white, 0.1)};
    }
  }

  ${props =>
    props.active &&
    `
      &::before {
        content: '';
        position: absolute;
        bottom: 15px; //padding-bottom - height
        left: 50%;
        transform: translate(-50%, 0);
        width: 4px;
        height: 4px;
        background-color: #ff1372;
        border-radius: 50%;
      }
    `}
`;

export { StyledSwitcher, SwitcherButton };
